import React, {useEffect} from "react";
import {connect} from "react-redux";

import JobEditPopupCartItem from "./JobEditPopupCartItem";
import UiSwitch from "../../PageLayout/UiSwitch";
import {setJobEditPopupActiveQuoteIndex, setJobEditPopupSearchText} from "./jobEditActions";


const JobEditPopupHeader = (props) => {

  const {jobEditPopupSearchText, setJobEditPopupSearchText, jobEditPopupRoomNames, jobEditPopupActiveQuoteIndex,
    setJobEditPopupActiveQuoteIndex} = props;

  const onSearchChange = (event) => {
    setJobEditPopupSearchText(event.target.value)
  }

  useEffect(() => {
    return () => {
      setJobEditPopupSearchText("");
    }
  }, []);

  return (
    <div className="pb-1 pl-15 pr-2 flex flex--center flex--between">
      <ul className="fix-ul flex flex--center color-gray4 bold font--14 line--14">
        <li className={"link border-box h-2 line--14 link margin-r8 p-05 pr-block radius-8"
          + (jobEditPopupActiveQuoteIndex == null ? " pr-block--active" : "")}
            onClick={() => setJobEditPopupActiveQuoteIndex(null)}>
          All Rooms
        </li>
        {jobEditPopupRoomNames.map((roomName, roomNameIndex) => {
          return (
            <li className={"link border-box h-2 line--14 link margin-r8 p-05 pr-block radius-8"
              + (roomNameIndex === jobEditPopupActiveQuoteIndex ? " pr-block--active" : "")}
                key={roomName}
                onClick={() => setJobEditPopupActiveQuoteIndex(roomNameIndex)}>
              {roomName}
            </li>
          )
        })}
      </ul>
      <input className="generic-popup-textbox mb-0 h-2 radius-5 width-auto"
             type="search"
             placeholder="Search"
             onChange={onSearchChange}
             value={jobEditPopupSearchText}/>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {jobEditPopupSearchText, jobEditPopupRoomNames, jobEditPopupActiveQuoteIndex} = store.jobEditPopupState;
  return {
    jobEditPopupSearchText,
    jobEditPopupRoomNames,
    jobEditPopupActiveQuoteIndex,
  };
};

const mapDispatchToProps = {
  setJobEditPopupSearchText,
  setJobEditPopupActiveQuoteIndex,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(JobEditPopupHeader)
)
